import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Show, SignIn, SignUp } from "@clerk/react";
import { Toaster } from "sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { AccountProvider } from "@/lib/account";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Landing from "@/pages/Landing";
import Browse from "@/pages/Browse";
import ProfileDetail from "@/pages/ProfileDetail";
import MyProfile from "@/pages/MyProfile";
import Plans from "@/pages/Plans";
import Wallet from "@/pages/Wallet";
import Chat from "@/pages/Chat";
import Interests from "@/pages/Interests";
import Shortlist from "@/pages/Shortlist";
import Invite from "@/pages/Invite";
import Admin from "@/pages/Admin";
import CityPage from "@/pages/CityPage";
import CountryPage, { CountriesIndex } from "@/pages/Countries";
import Stories from "@/pages/Stories";
import OfferBanner from "@/components/OfferBanner";
import { PrefsProvider } from "@/lib/prefs";

const Protected = ({ children }) => (
  <>
    <Show when="signed-in">{children}</Show>
    <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
  </>
);

const AuthPage = ({ children }) => (
  <div className="min-h-[80vh] flex items-center justify-center px-4 py-16 mandala-bg">{children}</div>
);

function App() {
  return (
    <BrowserRouter>
      <ClerkAuthProvider>
        <PrefsProvider>
        <AccountProvider>
          <div className="min-h-screen flex flex-col">
            <OfferBanner />
            <Nav />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/browse" element={<Browse />} />
                <Route path="/profile/:id" element={<ProfileDetail />} />
                <Route path="/plans" element={<Plans />} />
                <Route path="/me" element={<Protected><MyProfile /></Protected>} />
                <Route path="/wallet" element={<Protected><Wallet /></Protected>} />
                <Route path="/chat" element={<Protected><Chat /></Protected>} />
                <Route path="/chat/:pid" element={<Protected><Chat /></Protected>} />
                <Route path="/interests" element={<Protected><Interests /></Protected>} />
                <Route path="/shortlist" element={<Protected><Shortlist /></Protected>} />
                <Route path="/invite" element={<Protected><Invite /></Protected>} />
                <Route path="/admin" element={<Protected><Admin /></Protected>} />
                <Route path="/matrimony/:slug" element={<CityPage />} />
                <Route path="/countries" element={<CountriesIndex />} />
                <Route path="/country/:slug" element={<CountryPage />} />
                <Route path="/stories" element={<Stories />} />
                <Route path="/sign-in/*" element={<AuthPage><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></AuthPage>} />
                <Route path="/sign-up/*" element={<AuthPage><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></AuthPage>} />
              </Routes>
            </main>
            <Footer />
          </div>
          <Toaster theme="dark" position="top-center" richColors />
        </AccountProvider>
        </PrefsProvider>
      </ClerkAuthProvider>
    </BrowserRouter>
  );
}

export default App;
